export default {
  GET_WHATSAPP_TEMPLATES_REQUEST: "GET_WHATSAPP_TEMPLATES_REQUEST",
  GET_WHATSAPP_TEMPLATES_SUCCESS: "GET_WHATSAPP_TEMPLATES_SUCCESS",
  GET_WHATSAPP_TEMPLATES_FAIL: "GET_WHATSAPP_TEMPLATES_FAIL",

  GET_WHATSAPP_TEMPLATE_REQUEST: "GET_WHATSAPP_TEMPLATE_REQUEST",
  GET_WHATSAPP_TEMPLATE_SUCCESS: "GET_WHATSAPP_TEMPLATE_SUCCESS",
  GET_WHATSAPP_TEMPLATE_FAIL: "GET_WHATSAPP_TEMPLATE_FAIL",

  SELECT_WHATSAPP_TEMPLATE: "SELECT_WHATSAPP_TEMPLATE",
  WHATSAPP_TEMPLATE_DRAFT_CHANGE: "WHATSAPP_TEMPLATE_DRAFT_CHANGE",
  WHATSAPP_TEMPLATE_RESET_DRAFT: "WHATSAPP_TEMPLATE_RESET_DRAFT",

  SAVE_WHATSAPP_TEMPLATE_REQUEST: "SAVE_WHATSAPP_TEMPLATE_REQUEST",
  SAVE_WHATSAPP_TEMPLATE_SUCCESS: "SAVE_WHATSAPP_TEMPLATE_SUCCESS",
  SAVE_WHATSAPP_TEMPLATE_FAIL: "SAVE_WHATSAPP_TEMPLATE_FAIL",

  WHATSAPP_TEMPLATES_LOADING: "WHATSAPP_TEMPLATES_LOADING",
  WHATSAPP_TEMPLATE_SAVING: "WHATSAPP_TEMPLATE_SAVING",
};
